import { render, staticRenderFns } from "./resourceDetailUseRecord.vue?vue&type=template&id=47eacf38&scoped=true"
import script from "./resourceDetailUseRecord.vue?vue&type=script&lang=js"
export * from "./resourceDetailUseRecord.vue?vue&type=script&lang=js"
import style0 from "./resourceDetailUseRecord.vue?vue&type=style&index=0&id=47eacf38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eacf38",
  null
  
)

export default component.exports